<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Nombre *</label>
            <input
              v-model="nombre"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Dirección</label>
            <input
              v-model="direccion"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Teléfono</label>
            <input
              v-model="telefono"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Responsable</label>
            <select v-model="idResponsable" class="form-control">
              <option
                v-for="item in containers.responsables"
                :key="item.idPersona"
                :value="item.idPersona"
              >
                {{ item.nombre }}
              </option>
            </select>
          </div>
          <div>
            <div class="text-right">
              <button
                class="btn btn-sm btn-outline-success"
                :disabled="loading.crud"
                @click="onNuevo"
              >
                Nuevo
              </button>
              <button
                class="ml-2 btn btn-sm btn-primary"
                :disabled="loading.crud"
                @click="onGuardar"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
                <tr class="text-center align-middle">
                  <th style="width: 80px"></th>
                  <th>Nombre</th>
                  <th>Dirección</th>
                  <th>Teléfono</th>
                  <th>Responsable</th>
                  <th>UC</th>
                  <th>UM</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in containers.sedes"
                  :key="item.idSede"
                  class="align-middle text-center"
                >
                  <td>
                    <button
                      class="btn btn-xs btn-icon btn-light-warning"
                      @click="onEditar(item)"
                    >
                      <span class="fa fa-fw fa-pencil-alt"></span>
                    </button>
                    <button
                      class="btn btn-xs btn-icon btn-light-danger ml-2"
                      @click="onEliminar(item)"
                    >
                      <span class="fa fa-fw fa-trash-alt"></span>
                    </button>
                  </td>
                  <td>{{ item.nombre }}</td>
                  <td>{{ item.direccion }}</td>
                  <td>{{ item.telefono }}</td>
                  <td>{{ item.responsable }}</td>
                  <td>{{ item.usuarioCreador }}</td>
                  <td>{{ item.usuarioModif }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  layout: "app",
  data() {
    return {
      idSede: null,
      idResponsable: "",
      nombre: "",
      direccion: "",
      telefono: "",
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        responsables: [],
        sedes: [],
      },
    };
  },
  async created() {
    const vm = this;

    let {
      data: { content },
    } = await vm.axios.get("/mantenimiento/sedes");

    vm.containers.sedes = content.sedes;
    vm.containers.responsables = content.personasOficina;

    vm.loading.view = false;
  },
  methods: {
    onGuardar() {
      let vm = this;
      let responsable = vm.idResponsable,
        nombre = String(vm.nombre).trim(),
        direccion = String(vm.direccion).trim(),
        telefono = String(vm.telefono).trim();

      if (!nombre) {
        return vm.$swal.fire(
          "",
          "Completa los campos obligatorios (*)",
          "warning"
        );
      }

      vm.loading.crud = true;

      if (vm.idSede == null) {
        vm.axios
          .post("/mantenimiento/sedes", {
            idResponsable: responsable,
            nombre,
            direccion,
            telefono,
          })
          .then((response) => {
            vm.idSede = response.data.content.id;

            vm.containers.sedes.push({
              idSede: response.data.content.id,
              nombre,
              direccion,
              telefono,
              idResponsable: responsable,
              responsable:
                vm.containers.responsables.find(
                  (item) => item.idPersona == responsable
                )?.nombre || "",
              usuarioCreador: vm.$store.state.user.codigo,
            });

            vm.$toast.fire(response.data.message, "", "success");
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      } else {
        vm.axios
          .put(`/mantenimiento/sedes/${vm.idSede}`, {
            idResponsable: responsable,
            nombre,
            direccion,
            telefono,
          })
          .then((response) => {
            vm.containers.sedes.forEach((item) => {
              if (item.idSede == vm.idSede) {
                item.nombre = nombre;
                item.direccion = direccion;
                item.telefono = telefono;
                item.responsable =
                  vm.containers.responsables.find(
                    (item) => item.idPersona == responsable
                  )?.nombre || "";
                item.usuarioModif = vm.$store.state.user.codigo;
              }
            });

            vm.$toast.fire(response.data.message, "", "success");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onEditar(pItem) {
      let vm = this;
      let item = { ...pItem };
      vm.idSede = item.idSede;
      (vm.nombre = item.nombre), (vm.direccion = item.direccion || "");
      vm.telefono = item.telefono || "";
      vm.idResponsable = item.idResponsable;
    },
    async onEliminar(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
        "",
        "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(`/mantenimiento/sedes/${pItem.idSede}`)
          .then((response) => {
            let tempRegistros = [...vm.containers.sedes];
            vm.containers.sedes = tempRegistros.filter(
              (item) => item.idSede != pItem.idSede
            );
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onNuevo() {
      let vm = this;
      vm.idSede = null;
      vm.nombre = "";
      vm.direccion = "";
      vm.telefono = "";
      vm.idResponsable = "";
    },
  },
};
</script>
